"use strict";

exports.__esModule = true;
exports.getContainerStyle = getContainerStyle;
exports.getImageStyle = getImageStyle;
exports.getOuterInfoStyle = getOuterInfoStyle;
exports.getInnerInfoStyle = getInnerInfoStyle;

var _infoType = _interopRequireDefault(require("../../utils/constants/infoType"));

var _placements = _interopRequireDefault(require("../../utils/constants/placements"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getContainerStyle(styleParams) {
  return _objectSpread({}, (styleParams.imageInfoType === _infoType["default"].ATTACHED_BACKGROUND || styleParams.titlePlacement === _placements["default"].SHOW_ON_HOVER) && _objectSpread({}, getBorderStyle(styleParams.itemBorderRadius, styleParams.itemBorderWidth, styleParams.itemBorderColor), {}, boxShadow(styleParams)));
}

function boxShadow(styleParams) {
  var boxShadow = {};

  if (styleParams.itemEnableShadow) {
    var itemShadowBlur = styleParams.itemShadowBlur,
        itemShadowDirection = styleParams.itemShadowDirection,
        itemShadowSize = styleParams.itemShadowSize;
    var alpha = -1 * (Number(itemShadowDirection) - 90) / 360 * 2 * Math.PI;
    var shadowX = Math.round(itemShadowSize * Math.cos(alpha));
    var shadowY = Math.round(-1 * itemShadowSize * Math.sin(alpha));
    boxShadow = {
      boxShadow: shadowX + "px " + shadowY + "px " + itemShadowBlur + "px " + styleParams.itemShadowOpacityAndColor.value
    };
  }

  return boxShadow;
}

function getImageStyle(styleParams) {
  return _objectSpread({}, !(styleParams.titlePlacement === _placements["default"].SHOW_ON_HOVER) && (styleParams.imageInfoType === _infoType["default"].NO_BACKGROUND || styleParams.imageInfoType === _infoType["default"].SEPARATED_BACKGROUND) && _objectSpread({}, getBorderStyle(styleParams.itemBorderRadius, styleParams.itemBorderWidth, styleParams.itemBorderColor)));
}

function getBorderStyle(borderRadius, borderWidth, borderColor) {
  return _objectSpread({
    overflow: 'hidden',
    borderRadius: borderRadius,
    borderWidth: borderWidth + 'px',
    borderColor: borderColor && borderColor.value
  }, borderWidth && {
    borderStyle: 'solid'
  });
}

function getOuterInfoStyle(styleParams) {
  if (styleParams.imageInfoType === _infoType["default"].SEPARATED_BACKGROUND) {
    return _objectSpread({}, getBorderStyle(styleParams.textBoxBorderRadius, styleParams.textBoxBorderWidth, styleParams.textBoxBorderColor), {}, styleParams.titlePlacement === _placements["default"].SHOW_ABOVE && {
      marginBottom: styleParams.textImageSpace
    }, {}, styleParams.titlePlacement === _placements["default"].SHOW_BELOW && {
      marginTop: styleParams.textImageSpace
    });
  }

  return {};
}

function getInfoHorizontalPadding(styleParams) {
  if (styleParams.imageInfoType === _infoType["default"].SEPARATED_BACKGROUND || styleParams.imageInfoType === _infoType["default"].ATTACHED_BACKGROUND) {
    return styleParams.textsHorizontalPadding + 30;
  }

  return styleParams.textsHorizontalPadding;
}

function getInnerInfoStyle(styleParams) {
  return _objectSpread({
    height: styleParams.textBoxHeight
  }, (styleParams.imageInfoType === _infoType["default"].SEPARATED_BACKGROUND || styleParams.imageInfoType === _infoType["default"].ATTACHED_BACKGROUND) && styleParams.textBoxFillColor && styleParams.textBoxFillColor.value && {
    backgroundColor: styleParams.textBoxFillColor.value
  }, {
    textAlign: styleParams.galleryTextAlign
  }, (styleParams.titlePlacement === _placements["default"].SHOW_BELOW || styleParams.titlePlacement === _placements["default"].SHOW_ABOVE) && {
    paddingBottom: styleParams.textsVerticalPadding + 15 + 'px',
    paddingTop: styleParams.textsVerticalPadding + 15 + 'px'
  }, {
    paddingRight: getInfoHorizontalPadding(styleParams) + 'px',
    paddingLeft: getInfoHorizontalPadding(styleParams) + 'px',
    overflow: 'hidden',
    boxSizing: 'border-box'
  });
}